module.exports = __webpack_public_path__ + "static/media/LocationIcon.3c5dadf0.svg";